import { css } from "@emotion/react";

import { ACTIVITY_STATUS } from "../../../../../../shared";
import SingleLegendItem from "./SingleLegendItem";
import { LegendProps } from "./types";

const Legend = ({
    stats,
    isLoading,
    isEmpty,
    hoveredSlice,
    onHover,
    onClick
}: LegendProps) => {
    return (
        <div
            css={css({
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                margin: "3px 0 3px 32px"
            })}
        >
            <SingleLegendItem
                statusName={ACTIVITY_STATUS.Online}
                stats={stats}
                isLoading={isLoading}
                isEmpty={isEmpty}
                hoveredSlice={hoveredSlice}
                onHover={onHover}
                onClick={onClick}
            />

            <SingleLegendItem
                statusName={ACTIVITY_STATUS.Offline}
                stats={stats}
                isLoading={isLoading}
                isEmpty={isEmpty}
                hoveredSlice={hoveredSlice}
                onHover={onHover}
                onClick={onClick}
            />

            <SingleLegendItem
                statusName={ACTIVITY_STATUS.Inactive}
                stats={stats}
                isLoading={isLoading}
                isEmpty={isEmpty}
                hoveredSlice={hoveredSlice}
                onHover={onHover}
                onClick={onClick}
            />
        </div>
    );
};

export default Legend;
